module.exports = __webpack_public_path__ + "public/img/move_up.6193031a.svg";